<template>
	<ul
		class="grid"
		:style="`grid-template-columns: repeat(${columns.length}, auto);`"
	>
		<li
			class="grid grid-cols-subgrid col-span-full font-semibold text-[var(--text-primary)] gap-x-4"
		>
			<span v-for="column in columns" :key="column.accessorKey">
				{{ column.header }}
			</span>
		</li>
		<li
			v-for="row in rows"
			:key="row[keyCol]"
			class="grid border-t grid-cols-subgrid col-span-full gap-x-4"
		>
			<span v-for="column in columns" :key="column.accessorKey">
				{{
					column.displayFn
						? column.displayFn(row[column.accessorKey])
						: row[column.accessorKey]
				}}
			</span>
		</li>
	</ul>
</template>

<script setup lang="ts">
import type { AppColumn, AppRow } from "@/models/AppTable";

defineProps<{
	columns: AppColumn[];
	rows: AppRow[];
	keyCol: string;
}>();
</script>
